import Api from '../__helpers/api'

export const getTradeObjects = regionId => {
    return async (dispatch, getState) => {
        let loading = true
        let data = {}

        const handleDispatch = () => dispatch({
            type: 'GET_TRADE_OBJECTS',
            payload: {
                loading,
                data
            },
        })

        handleDispatch()

        window.navigator.geolocation.getCurrentPosition(success => {
            coordsFinished(success.coords.latitude, success.coords.longitude)
        }, () => {
            coordsFinished(null, null)
            console.log('Не бяха намерени GPS координати')
        })


        const coordsFinished = (lat, lon) => {
            Api.get('store-objects')
                .then(res => {
                    data = {
                        ...data,
                        all: res.data
                    }
                })
            Api.get(`store-addresses?region_id=${regionId}&lat=${lat}&lon=${lon}`)
                .then(res => {
                    data = {
                        ...data,
                        ...res.data
                    }
                })
                .finally(() => {
                    loading = false
                    handleDispatch()
                })
        }

    }
}

export const handleFilterBrands = brandId => {
    return async (dispatch, getState) => {
        const __tradeObjects = getState().tradeObjectsReducer.data

        const filteredNearest = __tradeObjects?.nearest?.filter(each => {
            return each.object?.id == brandId
        })

        const filteredRest = __tradeObjects?.rest?.filter(each => {
            return each.object?.id == brandId
        })

        dispatch({
            type: 'FILTER_TRADE_OBJECTS',
            payload: {
                data: {
                    ...__tradeObjects,
                    filteredNearest,
                    filteredRest,
                    filterByBrandId: __tradeObjects.filterByBrandId == brandId ? null : brandId
                }
            },
        })

    }
}

export const handleOnlineStores = objectId => {
    return async (dispatch, getState) => {
        Api.post('student/increase-store-objects-visits-count', {
            object_id: objectId
        })
    }
}